<template>
  <SectionPageShell section="media" title="Fotos / Dokumente">
    <section class="media-upload mb-3">
      <div class="media-upload__heading">
        <Icon icon="fa-pro-solid:cloud-arrow-up" />
        <div>
          <h2 class="h5 mb-1">Neue Dateien hochladen</h2>
          <p class="mb-0 text-muted">Dateien auswählen, Angaben ergänzen und direkt in die Mediathek laden.</p>
        </div>
      </div>
      <DropZone ref="dropzone" compact :uploading="uploading" @upload="onUpload" @abort="resetUpload" />
    </section>

    <section class="media-library">
      <div class="media-library__heading">
        <h2 class="h5 mb-1">Ihre Mediathek</h2>
        <p class="mb-0 text-muted">Alle Medien durchsuchen, bearbeiten oder löschen.</p>
      </div>
      <MediaList :editMode="true" />
    </section>
  </SectionPageShell>
</template>

<script>
import DropZone from "@/components/general/DropZone.vue";
import MediaList from "@/components/media/MediaList.vue";
import SectionPageShell from "@/components/base_type/SectionPageShell.vue";
import {useUserStore} from "@/stores/user";
import {useMediaStore} from "@/stores/media";
import {Helpers} from "@/helpers";

export default {
  name: "MediaIndex",
  components: {DropZone, MediaList, SectionPageShell},
  setup() {
    return {
      mediaStore: useMediaStore(),
      userStore: useUserStore(),
    }
  },
  data() {
    return {uploading: false}
  },
  created() {
    this.mediaStore.filters.type = []
  },
  methods: {
    resetUpload() {
      this.$refs.dropzone?.reset?.()
    },
    async onUpload(assetData) {
      this.uploading = true
      try {
        const uploads = await Promise.all(
          assetData.map((asset) => this.mediaStore.createAsset(this.userStore.user.organisation.kdnr, asset))
        )
        uploads.forEach(({data}) => {
          this.mediaStore.assets = [data, ...this.mediaStore.assets.filter((asset) => asset.id !== data.id)]
        })
        this.mediaStore.total += uploads.length
        this.resetUpload()
        Helpers.emitter.emit('success', `${uploads.length} Datei(en) hochgeladen.`)
      } catch (error) {
        Helpers.emitter.emit('error', error.response?.data?.message || error.message || 'Upload fehlgeschlagen')
      } finally {
        this.uploading = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import "src/scss/constants";

.media-upload,
.media-library {
  overflow: hidden;
  background: white;
  border: 1px solid #dce4ea;
  border-radius: 8px;
}

.media-upload {
  padding: 1rem;
}

.media-upload__heading {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 1rem;
}

.media-upload__heading > svg {
  font-size: 1.5rem;
  color: $manet_blue;
}

.media-library__heading {
  padding: 1rem 1rem 0;
}
</style>
